import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import { useEffect } from 'react';
import DataTableFilters from '../_common/Filters/DataTableFilters';
import TableContainer from '../_common/Table/TableContainer';
import AssemblyTemplatesTitleBar from './AssemblyTemplatesTitleBar';

const AssemblyTemplates = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  useEffect(() => {
    dispatch(setCurrentTable('assemblyTemplates'));
    return () => {
      dispatch(setCurrentTable(null));
    };
  }, []);

  return (
    <>
      {currentTableKey === 'assemblyTemplates' && (
        <>
          <AssemblyTemplatesTitleBar />
          <DataTableFilters disableExportReport />
          <TableContainer />
        </>
      )}
    </>
  );
};

export default AssemblyTemplates;
